import { createSwiper } from '../adapters/SwiperAdapter';

export const gallerySliderOnLoadHandler = () => {
    const galleryNavSwiper = createSwiper('.photo_gallery .gallery__nav', {
        slidesPerView: 5,
        spaceBetween: 5,
        centeredSlides: false,
        slideToClickedSlide: true,
        breakpoints: {
            0: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 5,
            },
        }
    });

    const galleryDisplaySwiper = createSwiper('.photo_gallery .gallery__display', {
        slidesPerView: 1,
        effect: 'fade',
        allowTouchMove: false,
        thumbs: {
            swiper: galleryNavSwiper,
        },
        navigation: {
            nextEl: '.photo_gallery .swiper-nav--arrow-next',
            prevEl: '.photo_gallery .swiper-nav--arrow-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        initialSlide: 0
    });

    if ( galleryNavSwiper == null && galleryDisplaySwiper == null ) {
        return;
    }

    galleryNavSwiper.on('slideChange', function () {
        galleryDisplaySwiper.slideTo(galleryNavSwiper.activeIndex);
    });
};